import React, { useState, useEffect } from 'react';
import { collection, doc, setDoc, query, where, getDocs, onSnapshot } from "firebase/firestore";
import { db } from '../firebase-config.js'
import firebase from 'firebase/compat/app';
import 'firebase/firestore';

//import NavbarBrowse from '../components/NavbarBrowse';
//import Cards from './Cards';

import { useShelters } from '../context/BrowseContext';

async function addPetToPetsCollection(){
  const colRef = collection(db, 'pets');

  await setDoc(doc(colRef), {
      
        id: "ldjf",
        name: "John The Cat",
        species: "cat", 
        breed: "Cheshire", 
        disposition: "goodWithChildren", 
        availability: "available",
        age: 12,
        description: "Cool cat.",
        imgUrl: "www.image.com"

    }
  );
}


      // {
      //   id: "ldjfeidjhklvufjeol",
      //   name: "Nicodemus",
      //   species: "other", 
      //   breed: "Rat", 
      //   disposition: "hungry", 
      //   availability: "available",
      //   age: 1,
      //   description: "Smart rat will keep you entertained.",
      //   imgUrl: "www.image.com"
      // }

function AddAccountsUtility() {
  // collection ref
  const colRef = collection(db, 'shelters');
  // queries
  const q = query(colRef, where("name", "==", "Happy Pets"))

  // realtime collection data
  // onSnapshot(q, (snapshot) => {
  //   let shelters = []
  //   snapshot.docs.forEach(doc => {
  //     shelters.push({ ...doc.data(), id: doc.id })
  //   })
  //   console.log(shelters)
  // })

  // Get all shelters
  // const unsub = onSnapshot(collection(db, 'shelters'), (snapshot) => {
  //   snapshot.docs.forEach(doc => {console.log("Current data: ", doc.data());})
    
  // });


  const shelter = useShelters()
  // console.log(shelter);

  const set = async () => {
    const shelters = collection(db, "shelters");
    const accounts = collection(db, "accounts");
    const owners_db = collection(db, "owners");
  //   await setDoc(doc(accounts), {
  //     type: "shelter",
  //     shelter: {
  //       name: "Kitten Mission",
  //       logoImgUrl: "test.com",
  //       website: "kittenmission.com",
  //     },
  //     user: {
  //       uid: "",
  //       email: "test@test.com",
  //       userName: "mission",
  //     },
  //     contactInfo: {
  //       phoneNumber: "555-555-5555",
  //       email: "test@test.com",
  //       city: "Seattle",
  //       street: "123 Main St.",
  //       state: "WA",
  //       zipCode: "90220",
  //     },
  //     Pets: {
  //       "JohnTheCat":
  //       {
  //         species: "cat", 
  //         breed: "Tabby", 
  //         disposition: "goodWithChildren", 
  //         availability: "available",
  //         age: 12,
  //         description: "Cool cat.",
  //         imgUrl: "www.image.com"
  //       },
  //       "Nicodemus":
  //       {
  //         species: "other", 
  //         breed: "Rat", 
  //         disposition: "hungry", 
  //         availability: "available",
  //         age: 1,
  //         description: "Smart rat will keep you entertained.",
  //         imgUrl: "www.image.com"
  //       }
  //     }
  //   }
  // )

    await setDoc(doc(accounts), {
      type: "owner",
      owner: {
        firstName: "Ada",
        lastName: "Lovelace",
        ownerImgUrl: "img.com",
        kids: true,
        ownerImgUrl: "test.com",
      },
      user: {
        uid: "",
        email: "test@test.com",
        userName: "luvvul",
      },
      contactInfo: {
        phoneNumber: "555-555-5555",
        email: "test@test.com",
        city: "Denver",
        street: "123 Main St.",
        state: "CO",
        zipCode: "80204",
      },
      Pets: {
        "JohnTheCat":
        {
          species: "cat", 
          breed: "Cheshire", 
          disposition: "goodWithChildren", 
          availability: "available",
          age: 12,
          description: "Cool cat.",
          imgUrl: "www.image.com"
        },
        "Nicodemus":
        {
          species: "other", 
          breed: "Rat", 
          disposition: "hungry", 
          availability: "available",
          age: 1,
          description: "Smart rat will keep you entertained.",
          imgUrl: "www.image.com"
        }
      }
    }
  );
  }
  
  const getShelter = async () => {
    const q = query(collection(db, "shelter"), where("Pets.name", "==", "Bella"));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      console.log(doc.id, " => ", doc.data());
    });
  }

  return (
    <div>
      {/* {set()} */}
      {/* <NavbarBrowse /> */}

      <p>text</p>
      <button className='form-input-btn' onClick={set} >submit</button>
      <button className='form-input-btn' onClick={getShelter}>retrieve</button>

      {/* {shelters.map(s => 
        <li key={s.id}>
          <div className='shelter'>
            s.name
          </div>
        </li>  
      )} */}

      {/* <Cards /> */}
    </div>
  );
}

export default AddAccountsUtility